// Static fallback data for SUV Engineers website preview

export const ONGOING = [
  { name: "EMMVEE Energy Pvt Ltd", client: "EMMVEE Energy Pvt Ltd", location: "Dabaspet", sector: "Industrial", scope: "Industrial electrical installation works." },
  { name: "EMMVEE Energy Pvt Ltd", client: "EMMVEE Energy Pvt Ltd", location: "Sulibele", sector: "Industrial", scope: "Industrial electrical installation works." },
  { name: "Sona College of Technology", client: "Sona College of Technology", location: "Salem", sector: "Educational", scope: "Campus electrification works." },
  { name: "One Health Trust Campus", client: "One Health Trust", location: "Chikkaballapur", sector: "Institutional", scope: "Campus electrical infrastructure." },
  { name: "MEC School", client: "MEC School", location: "Yelahanka", sector: "Educational", scope: "School building electrification." },
  { name: "KAS Building", client: "Government of Karnataka", location: "Infantry Road, Bangalore", sector: "Government", scope: "Building electrical works." },
  { name: "Police Quarters", client: "Karnataka State Police", location: "Mandya", sector: "Government", scope: "Residential quarters electrification." },
  { name: "JR Commercial Complex", client: "JR Group", location: "Koramangala, Bangalore", sector: "Commercial", scope: "Commercial complex electrical works." },
  { name: "Multi Cuisine Restaurant", client: "Private", location: "RR Nagar, Bangalore", sector: "Commercial", scope: "Restaurant interior electrification." },
  { name: "Toyota Showroom", client: "Sundaram Motors", location: "Bangalore", sector: "Showroom", scope: "Automotive showroom electrical fit-out." },
  { name: "Rashtrotthana Vidya Kendra (Phase 2)", client: "Rashtrotthana Parishat", location: "Hassan", sector: "Educational", scope: "Phase-2 campus electrification." },
  { name: "Rashtrotthana Vidya Kendra", client: "Rashtrotthana Parishat", location: "Devihosur, Haveri", sector: "Educational", scope: "Campus electrification works." },
  { name: "AEPL Office & Learning Center", client: "AEPL", location: "Mysore Road, Bangalore", sector: "Commercial", scope: "Office and learning centre electrical works." }
];

export const COMPLETED_SUV = [
  { name: "Mercedes-Benz Showroom", client: "Mercedes-Benz", location: "Airport Road, Bangalore", sector: "Showroom", scope: "Premium automotive showroom electrification." },
  { name: "Karle Hub-4", client: "Vervent (via Baldota Interiors)", location: "Bangalore", sector: "Commercial", scope: "Commercial tower interior electrical works." },
  { name: "Maxwatt Turbo Machinery LLP", client: "Maxwatt Turbo Machinery LLP", location: "Devanahalli", sector: "Industrial", scope: "Industrial electrical installation." },
  { name: "High Ground Police Station", client: "Karnataka State Police", location: "Bangalore", sector: "Government", scope: "Police station electrification." },
  { name: "Cubbon Park Police Station", client: "Karnataka State Police", location: "Bangalore", sector: "Government", scope: "Police station electrification." },
  { name: "Gonikoppa Fire Station", client: "Karnataka Fire & Emergency Services", location: "Gonikoppa", sector: "Government", scope: "Fire station electrical works." },
  { name: "Sentini Bottling Pvt Ltd", client: "Sentini Bottling Pvt Ltd", location: "Narasapura", sector: "Industrial", scope: "Bottling plant electrification." },
  { name: "Sri Kumaran's School", client: "Sri Kumaran's School", location: "Bangalore", sector: "Educational", scope: "School electrical works." },
  { name: "Resil Chemicals Pvt Ltd", client: "Resil Chemicals Pvt Ltd", location: "Malur", sector: "Industrial", scope: "Chemical plant electrification." },
  { name: "Dharmashala Lakshmi Narasimha Temple", client: "Temple Trust", location: "Mysore", sector: "Institutional", scope: "Temple complex electrical works." },
  { name: "BEML 1500HP Engine Test Cell", client: "BEML (via Sierra CP)", location: "Mysuru", sector: "Industrial", scope: "Engine test cell electrical systems." },
  { name: "TurningPoint Software Solutions Pvt Ltd", client: "TurningPoint Software Solutions", location: "Harohalli", sector: "IT", scope: "Office electrical works." },
  { name: "Exponent Energy Pvt Ltd", client: "Exponent Energy Pvt Ltd", location: "Hosur", sector: "Industrial", scope: "EV energy facility electrification." },
  { name: "Bharat Petroleum Corporation Ltd", client: "BPCL (via Densol Engineering)", location: "Karnataka", sector: "Industrial", scope: "Petroleum facility electrical works." },
  { name: "Epitome Infotech Solutions Pvt Ltd", client: "Epitome Infotech Solutions", location: "Bengaluru", sector: "IT", scope: "IT office electrification." },
  { name: "Madikeri SP Office", client: "Govt. (via Ramkrishy Infrastructure)", location: "Madikeri", sector: "Government", scope: "Office building electrical works." },
  { name: "Abhi Trust", client: "Abhi Trust", location: "Mysuru", sector: "Institutional", scope: "Trust building electrification." },
  { name: "K+M House", client: "Private Residence", location: "Bengaluru", sector: "Residential", scope: "Luxury residence electrification." },
  { name: "Concorde Corporate Office", client: "Concorde Group", location: "Bengaluru", sector: "Commercial", scope: "Corporate office electrical fit-out." },
  { name: "EMMVEE Photovoltaic Pvt Ltd", client: "EMMVEE Photovoltaic Pvt Ltd", location: "Bettahalasuru, Bangalore", sector: "Industrial", scope: "Solar manufacturing plant electrification." },
  { name: "Navin Fluorine Advanced Sciences Ltd", client: "Navin Fluorine", location: "Dahej, Gujarat", sector: "Industrial", scope: "Advanced sciences facility electrical works." },
  { name: "Kowshik Sankethi Sangha Conference Hall", client: "Kowshik Sankethi Sangha", location: "Mysore", sector: "Institutional", scope: "Conference hall electrification." },
  { name: "KSPH & IDCL Subdivision Office", client: "KSPH & IDCL", location: "Bengaluru", sector: "Government", scope: "Electrical work at subdivision office." },
  { name: "Wipro Enterprises Ltd", client: "Wipro Enterprises Ltd", location: "Bangalore", sector: "Industrial", scope: "Enterprise facility electrical works." },
  { name: "Sai Life Sciences Pvt Ltd", client: "Sai Life Sciences", location: "Turkapally Campus, Hyderabad", sector: "Industrial", scope: "Life sciences campus electrification." },
  { name: "Bidadi Industrial Association Office", client: "Bidadi Industrial Association", location: "Bangalore", sector: "Commercial", scope: "Association office electrical works." },
  { name: "Syngene International Ltd", client: "Syngene (via Densol Engineering)", location: "Bangalore", sector: "Industrial", scope: "Research facility electrical works." },
  { name: "Karvy Data Management Services Ltd", client: "Karvy Data Management", location: "Gwalior, M.P.", sector: "IT", scope: "Data management office electrification." },
  { name: "Veeravahana Udyog Pvt Ltd", client: "Veeravahana Udyog", location: "Bangalore", sector: "Industrial", scope: "Industrial electrical works." },
  { name: "SRM University", client: "SRM University", location: "Amaravati, Andhra Pradesh", sector: "Educational", scope: "University campus electrification." },
  { name: "One Trust Privacy Management Pvt Ltd", client: "OneTrust", location: "Bangalore", sector: "IT", scope: "Office electrical works." },
  { name: "CEONE Info Solutions", client: "CEONE Info Solutions", location: "Bangalore", sector: "IT", scope: "IT office electrification." },
  { name: "RJ Brooke Square", client: "RJ Developers", location: "Kundanahalli, Bangalore", sector: "Residential", scope: "Villament internal & external electrification." },
  { name: "CK Forum Mall", client: "Forum Malls", location: "Bangalore", sector: "Commercial", scope: "Shopping mall electrical works." },
  { name: "Happiest Minds", client: "Happiest Minds Technologies", location: "Bangalore", sector: "IT", scope: "Corporate office electrification." },
  { name: "Phoenix Mall", client: "Phoenix Mills", location: "Bangalore", sector: "Commercial", scope: "Mall electrical infrastructure." },
  { name: "Avenue Supermarts (DMart)", client: "Avenue Supermarts Ltd", location: "Bangalore", sector: "Commercial", scope: "Retail store electrification." },
  { name: "Mysore Police Commissioner's Office", client: "Karnataka State Police", location: "Mysore", sector: "Government", scope: "Highmast lighting project." },
  { name: "Aishwarya Residency", client: "SRM Group", location: "Bangalore", sector: "Residential", scope: "Residential apartment electrification." },
  { name: "Sheorey Digital Systems", client: "Sheorey Digital Systems", location: "Bangalore", sector: "IT", scope: "Office electrical works." },
  { name: "Mitsubishi Hitachi", client: "Mitsubishi Hitachi Power Systems", location: "Bangalore", sector: "Industrial", scope: "Industrial facility electrical works." },
  { name: "H&M Retail Outlet", client: "H&M", location: "Xperia Mall, Mumbai", sector: "Showroom", scope: "Retail outlet electrification." },
  { name: "Sai Rachana", client: "Sai Rachana", location: "Kanakapura Road, Bangalore", sector: "Residential", scope: "Residential electrification." },
  { name: "Wipro Enterprises Pvt Ltd", client: "Wipro Enterprises", location: "Koramangala, Bangalore", sector: "IT", scope: "Corporate office electrical works." },
  { name: "Thielenhaus Micro Finish Pvt Ltd", client: "Thielenhaus Micro Finish", location: "Peenya, Bangalore", sector: "Industrial", scope: "Precision engineering plant electrification." },
  { name: "Cheer Breweries Limited", client: "Cheer Breweries Ltd", location: "Kadakola Industrial Area, Mysore", sector: "Industrial", scope: "Highmast lighting works." },
  { name: "GSSS Engineering College (Hostel Block)", client: "GSSS Engineering College", location: "Mysore", sector: "Educational", scope: "Hostel block electrification." },
  { name: "Fowler Westrup India Pvt Ltd", client: "Fowler Westrup India", location: "Bangalore", sector: "Industrial", scope: "Industrial electrical works." },
  { name: "Aequs Engineered Plastics Pvt Ltd", client: "Aequs Engineered Plastics", location: "Belgaum", sector: "Industrial", scope: "Industrial electrification works." },
  { name: "Thrive Co-Work Space", client: "Thrive", location: "Koramangala, Bangalore", sector: "Commercial", scope: "Co-working space electrical fit-out." },
  { name: "Venkatesh Valluri Office", client: "Venkatesh Valluri", location: "Brigade IRV, Bangalore", sector: "Commercial", scope: "Office interior electrical works." },
  { name: "Advaith Foundation", client: "Advaith Foundation", location: "Bangalore", sector: "Institutional", scope: "External electrification work." },
  { name: "Indra Priyadarshini Educational Institution", client: "Indra Priyadarshini Institution", location: "Galigar, Bangalore", sector: "Educational", scope: "Institutional electrification." },
  { name: "Sinewy Toughen Glass", client: "Sinewy Toughen Glass", location: "Doddaballapura", sector: "Industrial", scope: "Glass plant electrification." },
  { name: "Vydehi School of Excellence", client: "Vydehi School of Excellence", location: "Bangalore", sector: "Educational", scope: "School electrification works." },
  { name: "GSSS Engineering College (New Academic Block)", client: "GSSS Engineering College", location: "Mysore", sector: "Educational", scope: "New academic block electrification." },
  { name: "Sharekhan", client: "Sharekhan", location: "BEL Road, Bangalore", sector: "Commercial", scope: "Office electrical works." },
  { name: "H&M Retail Outlet", client: "H&M", location: "Prozone Mall, Coimbatore", sector: "Showroom", scope: "Retail outlet electrification." }
];

export const LEGACY_SECTORS = {
  "Biotech & Hospitals": [
    "Saint John's Hospital - Silver Jubilee Block", "Indus West Side Hospital, Kengeri",
    "Shushrutha Eye Hospital, Mysore", "ICON Nursing College, Bangalore", "G.V.K. Biosciences, Hyderabad",
    "Institute of Population Health & Research Centre (St. John's & Lotus Labs)", "Jubilant Biosys Ltd",
    "aBexome Biosciences", "Aurigene Discovery Technologies Ltd", "Theramyte Biologics",
    "Norwich Clinical Services, Bangalore", "Lotus Labs Pvt Ltd"
  ],
  "Pharmaceutical & Clinical Research": [
    "Apotex Research India Pvt Ltd, Bangalore", "Kumar Organics Pvt Ltd, Bangalore",
    "Lotus Labs Pvt Ltd, Anandrao Circle, Bangalore", "Jubilant Biosys"
  ],
  "IT & Communication": [
    "Wipro Technologies Ltd", "Infosys Technologies Ltd", "Tata Consultancy Services Ltd",
    "Sasken Communication Ltd", "IBM Ltd", "Acer India Ltd", "RelQ Software Pvt Ltd", "CMC Limited",
    "Valtech Systems", "Indigo Lever Ltd", "Touchtel", "Deduco Software Systems India Pvt Ltd",
    "Sobha Renaissance Information Technologies Pvt Ltd", "Object Orb Technologies Ltd", "Parsoft Pvt Ltd",
    "Systemlogic (I) Pvt Ltd", "Tata Elxsi Limited, Hyderabad", "Marlabs Software Pvt Ltd",
    "Starent Networks", "Subex", "Quintiles", "Persistent Technologies", "CRMIT", "Red Prairie",
    "Replicon", "Applied Materials", "Think Three Technologies", "EMC Square", "SNN"
  ],
  "Datacenters": [
    "Amazon", "Nouns Technologies", "Papricas (Dream Works)", "HP", "Wipro", "McAfee", "Toshiba", "Aricent"
  ],
  "Industrial & Engineering": [
    "Maxwatt Turbines Private Limited", "EMVEE Solar Systems Pvt Ltd (Dabaspet & Bellary Road)",
    "Bill Forge Pvt Ltd", "Volvo Bus Body Technologies India Pvt Ltd", "Cigfil - ITC",
    "Intergardens India Pvt Ltd", "Jindal Vijayanagar Steels Ltd, Toranagallu", "Wipro Fluid Power Ltd",
    "Rangsons Electronics Pvt Ltd", "Rane (Madras) Limited", "Brakes India Ltd, Mysore", "ABB Ltd, Bangalore",
    "Carrier Refrigeration India Pvt Ltd", "Acer India Ltd (Factory), Puducherry", "Ace Designers Ltd",
    "KTMS Engineering Pvt Ltd", "GEC Alsthom Ltd", "Sansera Engineering Pvt Ltd", "V3 Engineers Pvt Ltd",
    "Synergy Lifestyles Pvt Ltd", "Fouress Engineering (India) Ltd", "Juvari Cements", "Toyota Boshoku",
    "Bosch", "United Spirits", "SKF Bearings"
  ],
  "Food Processing": [
    "Kisan Parle", "Sudhamayi Food Products", "Alternative Food Process", "Unicorn Agro Foods",
    "SFRB Food Processing Pvt Ltd, Hoskote", "Sunsip, Madanapalli"
  ],
  "Warehouse & Logistics": [
    "DHL Express (Tiruppur, Secunderabad, Bangalore)", "Warehouse for M/s. Redington, Gummidipundi",
    "Warehouse for M/s. Raymonds, Whitefield", "Warehouse for M/s. Apotex, Jigani Bommasandra",
    "Warehouse for M/s. Kumar Organics, Hassan"
  ],
  "Educational Institutions": [
    "GSSS Engineering College for Women, Mysore", "SKSVMA College of Engineering, Gadag",
    "Amrith Educational Institute", "Apollo Educational Trust", "Cauvery School, Mysore",
    "Red Bridge International School", "Kumarans Educational Institute", "Mitra Academy, Bannerghatta Road",
    "Little Flower Public School, Hoskerehalli", "Goutham Educational Institution, Rajajinagar"
  ],
  "Banking, Financial & Insurance": [
    "ING Vysya Bank (Call Centre, Regional Office & 50+ branches)", "ICICI Banks, Bangalore & Hyderabad",
    "IndusInd Bank, Chennai & 7 branches", "Tata AIG Life Insurance Co. Ltd, Chennai & Bangalore",
    "Bank of America, Bangalore", "Union Bank of India, Bangalore",
    "Economic Development Board of Bahrain, Bangalore", "Birla Sunlife Insurance Co. Ltd, Bangalore & Kolkata",
    "ING Vysya Life Insurance Co. Ltd, Bangalore & Delhi", "Canara Bank - Head Office", "Indian Bank, Bangalore"
  ],
  "Hotels, Clubs & Resorts": [
    "Doddis Resorts", "Basil Hotels", "Kaynes Hotels Pvt Ltd, Mysore", "Urban Edge Hotel - Aloft Hotel",
    "CSI Fuller Hotel, Bangalore", "Fitness First, Bangalore", "Swathi Hotel, Banjara Hills, Hyderabad",
    "Secunderabad Club", "Oblivion Clubs, Indiranagar", "Purple Haze Pub, Residency Road",
    "Athena Resorts, Bangalore", "Quality Inn, Hitech City, Hyderabad", "Manasa Hotel, Kakinada",
    "The President Hotel, Hubli", "Rashi Developers"
  ],
  "Shopping Malls & Showrooms": [
    "Shoppers Stop Ltd, Bannerghatta Road", "Pantaloon Retails India Pvt Ltd (Hyderabad, Chennai, Bangalore)",
    "Mont Blanc, Leela Palace, Bangalore", "Technigroup, Indiranagar", "Italian Furniture Showroom, Bangalore",
    "Dockers Showroom, Begumpet, Hyderabad", "Advaith Hyundai, Mysore", "B.M. Habitat Mall & Multiplex, Mysore",
    "Big Bazaar", "Kala Nikethan"
  ],
  "Apartments & Bungalows": [
    "Akshaya Enclave, Basavanagudi", "Parle Products", "Iris Apartments",
    "Around 20 Bungalows - S.A. Properties, Bangalore", "Malibu Enclave (162 Flats)"
  ],
  "Garment Industries": [
    "ITC Cigfil, Bangalore", "Synergy Lifestyles Pvt Ltd", "Sachik Home Textiles Ltd", "Laguna Clothing"
  ],
  "Outstation Projects": [
    "Acer India, New Delhi", "Wipro, Noida", "ING Vysya, New Delhi", "TCS, Cochin, Kerala",
    "Redington (India) Ltd, Chennai", "Wipro Ltd, Cochin", "GVK Biosciences, Hyderabad", "ABB, Hyderabad",
    "Karvy & Co., Hyderabad"
  ],
  "Government & Infrastructure": [
    "Traffic Management - Government of Bangalore", "Layout for Mr. Venkataraman, Anjanapura",
    "Palash Layout, Bogadi Road, Mysore"
  ]
};

// Transform ONGOING, COMPLETED_SUV, and LEGACY into a unified array of Projects
export const STATIC_PROJECTS = (() => {
  const list = [];
  let order = 0;

  // Add ongoing current projects
  ONGOING.forEach((p) => {
    list.push({
      id: `ongoing-${order}`,
      name: p.name,
      client: p.client || "",
      location: p.location || "",
      sector: p.sector || "General",
      scope: p.scope || "",
      status: "ongoing",
      group: "current",
      featured: true,
      order: order++
    });
  });

  // Add completed current projects
  COMPLETED_SUV.forEach((p) => {
    list.push({
      id: `completed-${order}`,
      name: p.name,
      client: p.client || "",
      location: p.location || "",
      sector: p.sector || "General",
      scope: p.scope || "",
      status: "completed",
      group: "current",
      featured: false,
      order: order++
    });
  });

  // Add legacy projects
  Object.entries(LEGACY_SECTORS).forEach(([sector, names]) => {
    names.forEach((name) => {
      list.push({
        id: `legacy-${order}`,
        name: name,
        client: "",
        location: "",
        sector: sector,
        scope: "",
        status: "completed",
        group: "legacy",
        featured: false,
        order: order++
      });
    });
  });

  return list;
})();

export const getStaticStats = () => {
  const ongoing = STATIC_PROJECTS.filter((p) => p.status === "ongoing" && p.group === "current").length;
  const completed = STATIC_PROJECTS.filter((p) => p.status === "completed" && p.group === "current").length;
  const legacy = STATIC_PROJECTS.filter((p) => p.group === "legacy").length;
  const total = STATIC_PROJECTS.length;
  return { ongoing, completed, legacy, total };
};

// Generate gallery seed items
const GALLERY_GROUPS = [
  { prefix: "emmvee", category: "EMMVEE Energy", count: 4 },
  { prefix: "mtm", category: "Maxwatt Turbo Machinery", count: 11 },
  { prefix: "ocp", category: "Other Commercial Projects", count: 22 },
  { prefix: "wipro", category: "Wipro Enterprises", count: 6 },
  { prefix: "wiproblr", category: "Wipro — Bangalore", count: 6 },
  { prefix: "elw", category: "Electrical Works", count: 6 }
];

export const STATIC_GALLERY = (() => {
  const list = [];
  let order = 0;
  GALLERY_GROUPS.forEach(({ prefix, category, count }) => {
    for (let i = 1; i <= count; i++) {
      list.push({
        id: `/assets/gallery/${prefix}${i}.jpg`,
        category: category,
        caption: `${category} site installation photo #${i}`,
        order: order++
      });
    }
  });
  return list;
})();
